module.exports = __webpack_public_path__ + "static/media/magic_2_looped_white.09a2c932.svg";